


import React from "react";
// =================================================================
// 1. POLYFILLS (MUST BE AT THE VERY TOP)
// =================================================================
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// =================================================================
// 2. TIZEN 2.4 / WEBOS 3.0 FIX (THE "CRASH" PREVENTER)
// =================================================================
// Older TVs claim to have Map/Set, but they are broken/incomplete.
// We must delete the native versions so the polyfill above takes over.
// Without this, React Hooks (useMemo/useCallback) will CRASH the app.
if (global.Map && !global.Map.prototype.forEach) {
    console.warn("Detected broken Map implementation. Replaced with Polyfill.");
    global.Map = undefined; 
}
if (global.Set && !global.Set.prototype.forEach) {
    console.warn("Detected broken Set implementation. Replaced with Polyfill.");
    global.Set = undefined;
}

// Fix for "ResizeObserver loop limit exceeded" on older browsers
if (!window.ResizeObserver) {
    // You might need: npm install resize-observer-polyfill
    try {
        window.ResizeObserver = require('resize-observer-polyfill');
    } catch (e) {
        console.log("ResizeObserver polyfill not found");
    }
}
/*old Code*/

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<App />);

/*new Code*/

// Define a renderApp function

const rootElement = document.getElementById("root");
let root = ReactDOM.createRoot(rootElement);
const renderApp = () => {
  root.render(<App />);
};

// Render the app initially
renderApp();

// Define the appReload function globally
window.appReload = () => {
  localStorage.clear();
  localStorage.setItem("AppLanguage", "English");
  localStorage.setItem("LoginScreen", "LoginPage");
  console.log("Clearing root and reloading the app...");
  root.unmount();
  root = ReactDOM.createRoot(document.getElementById("root"));
  renderApp();
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
